define((require) => {
    "use strict";

    const HttpStatusCodes = require("shared/util/HttpStatusCodes");

    const MAX_FILE_SIZE = 5242880; // 5 MB

    return {

        /**
         * Pre-validates the SyncManager when uploading files to Creator.
         * @param {File|Object}         File to be validated.
         * @param {Boolean}             Boolean indicating whether the same file is being uploaded.
         *
         * @return {HttpStatusCodes}    An http status code to be returned to the Sync Manager.
         */
        validate(file, isSameFileBeingUploaded, supportedTypes) {
            if (this._hasZeroSize(file)) {
                return HttpStatusCodes.LENGTH_REQUIRED;
            }

            if (this._hasExceededMaxSize(file)) {
                return HttpStatusCodes.REQUEST_ENTITY_TOO_LARGE;
            }

            if (!this._hasValidExtension(file, supportedTypes)) {
                return HttpStatusCodes.UNSUPPORTED_MEDIA_TYPE;
            }

            if (this._hasUploadAlreadyInProgress(file, isSameFileBeingUploaded)) {
                return HttpStatusCodes.CONFLICT;
            }

            return HttpStatusCodes.OK;
        },

        /**
         * Check for file size.
         *
         * @param {File|Object} File to be validated.
         * @returns {Boolean} True if file is null, undefined or has zero size.
         */
        _hasZeroSize(file) {
            return !file || file.size === 0;
        },

        /**
         * Checks for file max size.
         *
         * @param {File|Object} File to be validated.
         * @returns {Boolean} True if file is is exceeding maximum size.
         */
        _hasExceededMaxSize(file) {
            return !this._hasZeroSize(file) && file.size > MAX_FILE_SIZE;
        },

        /**
         * Checks for file extension.
         *
         * @param {File|Object} File to be validated.
         * @returns {Boolean} True if file extension is supported.
         */
        _hasValidExtension(file, supportedTypes) {
            if (this._hasZeroSize(file)) {
                return false;
            }

            let name = file.name || "";
            const i = name.lastIndexOf(".");

            // Make sure extension is valid...
            if (i !== -1) {
                name = name.substring(i + 1).toLowerCase();

                if (supportedTypes.indexOf(name) === -1) {
                    return false;
                }
            }

            return true;
        },

        /**
         * Checks for conflicting concurrent uploads.
         *
         * @param {File|Object} File to be validated.
         * @param {Boolean}     Whether file is being uploaded from Sync Manager.
         *
         * @returns {Boolean}   True if same file is being uploaded in Creator..
         */
        _hasUploadAlreadyInProgress(file, isSameFileBeingUploadedFunction) {
            if (this._hasZeroSize(file)) {
                return false;
            }

            return Boolean(isSameFileBeingUploadedFunction);
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/validators/FileSyncManagerValidator.js